import React, { useState } from 'react';
import Input from '../ui/Input';
import ImageUploadButton from '../ui/ImageUploadButton';
import MediaLibraryModal from './MediaLibraryModal';
import Button from '../ui/Button';
import Icon from '../AppIcon';

const ImageUploadField = ({
  label,
  value,
  onChange,
  onUploadSuccess,
  showPreview = true,
  placeholder = 'Enter image URL or upload',
  description,
  error,
  required = false,
  weddingId,
  ...inputProps
}) => {
  const [uploadError, setUploadError] = useState(null);
  const [imageLoadError, setImageLoadError] = useState(false);
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);

  const handleUploadSuccess = (url) => {
    setUploadError(null);
    setImageLoadError(false);
    if (onUploadSuccess) {
      onUploadSuccess(url);
    } else if (onChange) {
      // Simulate input change event
      onChange({ target: { value: url } });
    }
  };

  const handleUploadError = (error) => {
    setUploadError(error);
  };

  const handleImageError = () => {
    setImageLoadError(true);
  };

  const handleSelectFromLibrary = (url) => {
    setUploadError(null);
    setImageLoadError(false);
    if (onUploadSuccess) {
      onUploadSuccess(url);
    } else if (onChange) {
      onChange({ target: { value: url } });
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2 items-end">
        <div className="flex-1">
          <Input
            label={label}
            type="text"
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            description={description}
            error={error || uploadError}
            required={required}
            {...inputProps}
          />
        </div>
        <Button
          variant="outline"
          size="default"
          onClick={() => setShowMediaLibrary(true)}
          className="mb-0"
          title="Choose from Media Library"
        >
          <Icon name="FolderOpen" size={16} />
        </Button>
        <ImageUploadButton
          onUploadSuccess={handleUploadSuccess}
          onUploadError={handleUploadError}
          buttonText="Upload"
          buttonVariant="outline"
          size="default"
          className="mb-0"
          weddingId={weddingId}
        />
      </div>

      <MediaLibraryModal
        isOpen={showMediaLibrary}
        onClose={() => setShowMediaLibrary(false)}
        onSelectImage={handleSelectFromLibrary}
        weddingId={weddingId}
      />

      {showPreview && value && (
        <div className="relative w-full h-32 rounded-lg overflow-hidden border border-gray-200 bg-gray-50">
          {!imageLoadError ? (
            <img
              src={value}
              alt="Preview"
              className="w-full h-full object-contain"
              onError={handleImageError}
            />
          ) : (
            <div className="flex items-center justify-center h-full text-gray-400 text-sm">
              Failed to load image
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageUploadField;
